import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["stroke", "size"],
    _excluded2 = ["stroke", "size"],
    _excluded3 = ["stroke", "size"],
    _excluded4 = ["stroke", "size"],
    _excluded5 = ["stroke", "size"],
    _excluded6 = ["stroke", "size"],
    _excluded7 = ["stroke", "size"],
    _excluded8 = ["stroke", "size"],
    _excluded9 = ["stroke", "size"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { memo } from 'react';
import IslandTravelUmbrellaIcon from './island-travel-umbrella-icon';
import { BarIcon, CucinaIcon, SalaIcon, ReceptionIcon } from './domain-interest-icons';
import { GlobeEuropeAfricaIcon as _GlobeEuropeAfricaIcon } from '@heroicons/react/24/outline';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StagionaleIcon = /*#__PURE__*/memo(function (_ref) {
  var stroke = _ref.stroke,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 32 : _ref$size,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 33 32"
  }, rest), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      stroke: stroke,
      strokeLinejoin: "round",
      strokeWidth: "2",
      d: "M7.455 20.773c.892 0 1.62.73 1.62 1.622v5.845H5.834v-5.845c0-.893.73-1.622 1.622-1.622zM26.359 20.773c.892 0 1.621.73 1.621 1.622v5.845h-3.228v-5.845c0-.893.73-1.622 1.622-1.622h-.015zM7.871 28.21h17.908M8.957 23.898h15.721"
    }), /*#__PURE__*/_jsx("path", {
      stroke: stroke,
      strokeLinejoin: "round",
      strokeWidth: "2",
      d: "M7.454 20.778v-2.663c0-1.07.878-2.008 1.949-2.008h5.563c1.07 0 1.948.938 1.948 2.008v5.756M26.388 20.778v-2.663c0-1.07-.877-2.008-1.948-2.008h-5.563c-1.07 0-1.948.938-1.948 2.008v5.756"
    }), /*#__PURE__*/_jsx("path", {
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      d: "M11.324 10.134l2.973-2.419c.6-.474 1.344-.474 1.945 0l1.591 1.618"
    }), /*#__PURE__*/_jsx("path", {
      fill: stroke,
      d: "M17.206 8.099a1 1 0 101.254 1.558l-1.254-1.558zm1.276.257l-.62-.785-.007.006.627.779zm1.945 0l.63-.776a.676.676 0 00-.01-.01l-.62.786zm-1.967 1.3l.649-.521-1.254-1.558-.649.522 1.254 1.558zm.641-.515c.238-.188.468-.188.706 0l1.24-1.57c-.965-.761-2.22-.761-3.185 0l1.24 1.57zm.695-.01l1.945 1.582 1.261-1.552-1.945-1.581-1.261 1.552z"
    }), /*#__PURE__*/_jsx("path", {
      stroke: stroke,
      strokeLinejoin: "round",
      strokeWidth: "2",
      d: "M21.807 4h-9.85a.79.79 0 00-.79.79v6.926c0 .437.353.79.79.79h9.85a.79.79 0 00.791-.79V4.791a.79.79 0 00-.79-.791z"
    })]
  }));
});
var DeterminatoIcon = /*#__PURE__*/memo(function (_ref2) {
  var stroke = _ref2.stroke,
      size = _ref2.size,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 33 32",
    children: [/*#__PURE__*/_jsxs("g", {
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      clipPath: "url(#clip0_1841_17847)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M13.834 2.667h5.333M12.5 13.333l4 4M27.167 6.667l-3.12 3.12M25.834 5.333L28.5 8M6.19 14.667c1.184-4.597 5.342-8 10.31-8 5.89 0 10.666 4.776 10.666 10.667C27.166 23.224 22.39 28 16.5 28"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10.378 24.545l-.26 2.054a.971.971 0 01-.277.565l-.826.826a.486.486 0 01-.687 0l-3.485-3.485a.486.486 0 010-.687l.839-.838a.966.966 0 01.533-.272l2.004-.322.32-2.003a.976.976 0 01.273-.533l.84-.84c.189-.19.497-.19.686 0l3.485 3.485c.19.19.19.498 0 .687l-.826.827a.972.972 0 01-.566.276l-2.053.26z"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_1841_17847",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0H32V32H0z",
          transform: "translate(.5)"
        })
      })
    })]
  });
});
var IndeterminatoIcon = /*#__PURE__*/memo(function (_ref3) {
  var stroke = _ref3.stroke,
      size = _ref3.size,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 33 32",
    children: [/*#__PURE__*/_jsxs("g", {
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      clipPath: "url(#clip0_1841_17814)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M13.834 3.667h5.333M12.5 14.333l4 4M27.167 7.667l-3.12 3.12M25.834 6.333L28.5 9M6.19 15.667c1.184-4.597 5.342-8 10.31-8 5.89 0 10.666 4.776 10.666 10.667C27.166 24.224 22.39 29 16.5 29M8.339 23.482c-.453.497-1.834 1.885-3.114 1.885v-.002l-.004.002a2.054 2.054 0 110-4.11l.005.002v-.002c1.28 0 2.66 1.387 3.114 1.885l.16.17-.161.17z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.66 23.482c.454.497 1.834 1.885 3.114 1.885v-.002l.005.002a2.054 2.054 0 10-.001-4.11l-.005.002v-.002c-1.28 0-2.66 1.387-3.113 1.885l-.16.17.16.17z"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_1841_17814",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0H32V32H0z",
          transform: "translate(.5)"
        })
      })
    })]
  });
});
var StageTirocinioIcon = /*#__PURE__*/memo(function (_ref4) {
  var stroke = _ref4.stroke,
      size = _ref4.size,
      rest = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 33 32",
    children: [/*#__PURE__*/_jsxs("g", {
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      clipPath: "url(#clip0_1841_17925)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M15.167 28H8.5a2.665 2.665 0 01-2.667-2.667V6.667A2.666 2.666 0 018.5 4h16a2.666 2.666 0 012.667 2.667v6.666M4.5 10.667h3.107M4.5 16h3.107M4.34 21.333h3.267M12.5 10.667h9.333M12.5 14.667h4"
      }), /*#__PURE__*/_jsx("path", {
        d: "M27.167 21.333v-2.667a1.333 1.333 0 00-1.334-1.333h-2.666a1.334 1.334 0 00-1.334 1.333v2.667M28.055 21.333h-7.11c-.983 0-1.779.746-1.779 1.667v3.333c0 .92.796 1.667 1.778 1.667h7.111c.982 0 1.778-.747 1.778-1.667V23c0-.92-.796-1.667-1.778-1.667z"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_1841_17925",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0H32V32H0z",
          transform: "translate(.5)"
        })
      })
    })]
  });
});
var PartTimeIcon = /*#__PURE__*/memo(function (_ref5) {
  var stroke = _ref5.stroke,
      size = _ref5.size,
      rest = _objectWithoutProperties(_ref5, _excluded5);

  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 33 32",
    children: [/*#__PURE__*/_jsxs("g", {
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      clipPath: "url(#clip0_1828_17191)",
      children: [/*#__PURE__*/_jsx("path", {
        strokeWidth: "2",
        d: "M16.5 4c6.628 0 12 5.372 12 12s-5.372 12-12 12"
      }), /*#__PURE__*/_jsx("path", {
        strokeWidth: "1.5",
        d: "M17.121 26L15 28.121l2.121 2.122"
      }), /*#__PURE__*/_jsx("path", {
        strokeWidth: "2",
        d: "M12.4 27.265a12.003 12.003 0 01-3.61-2.076M8.79 6.81a11.945 11.945 0 013.61-2.076M4.692 13.917a11.942 11.942 0 011.423-3.913M4.692 18.081a11.942 11.942 0 001.423 3.913M16.124 10.648v6.202l4.875 2.972"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_1828_17191",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0H32V32H0z",
          transform: "translate(.5)"
        })
      })
    })]
  });
});
var FullTimeIcon = /*#__PURE__*/memo(function (_ref6) {
  var stroke = _ref6.stroke,
      size = _ref6.size,
      rest = _objectWithoutProperties(_ref6, _excluded6);

  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 27 27",
    children: /*#__PURE__*/_jsx("path", {
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      d: "M18.413 14.16h-6.2M13.013 1.347a12 12 0 100 24 12 12 0 000-24zM12.213 14.16V6.693"
    })
  });
});
var SpezzatoIcon = /*#__PURE__*/memo(function (_ref7) {
  var stroke = _ref7.stroke,
      size = _ref7.size,
      rest = _objectWithoutProperties(_ref7, _excluded7);

  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "27",
    height: "26",
    fill: "none",
    viewBox: "0 0 27 26",
    children: [/*#__PURE__*/_jsx("path", {
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      d: "M13 8v5.408L17 16"
    }), /*#__PURE__*/_jsx("path", {
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      d: "M13.5 1c6.627 0 12 5.373 12 12s-5.373 12-12 12M9.4 24.265a12.002 12.002 0 01-3.61-2.076M5.79 3.81A11.945 11.945 0 019.4 1.734M1.692 10.917c.24-1.379.722-2.705 1.423-3.917M1.692 15.081c.24 1.38.722 2.706 1.423 3.919"
    })]
  });
});
var InteroIcon = /*#__PURE__*/memo(function (_ref8) {
  var stroke = _ref8.stroke,
      size = _ref8.size,
      rest = _objectWithoutProperties(_ref8, _excluded8);

  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "26",
    height: "26",
    fill: "none",
    viewBox: "0 0 26 26",
    children: [/*#__PURE__*/_jsx("path", {
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      d: "M12 8v5.408L16 16"
    }), /*#__PURE__*/_jsx("path", {
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      d: "M13 1c6.627 0 12 5.373 12 12s-5.373 12-12 12M13 1C6.373 1 1 6.373 1 13s5.373 12 12 12"
    })]
  });
});
var NoWeekendIcon = /*#__PURE__*/memo(function (_ref9) {
  var stroke = _ref9.stroke,
      size = _ref9.size,
      rest = _objectWithoutProperties(_ref9, _excluded9);

  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "33",
    height: "32",
    fill: "none",
    viewBox: "0 0 33 32",
    children: [/*#__PURE__*/_jsx("g", {
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      clipPath: "url(#clip0_1841_18070)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M26.005 22.855a3.944 3.944 0 002.126-5.578l-3.37-6.254a1.334 1.334 0 00-1.629-.622l-3.057 1.111c-.632.23-.994.893-.846 1.548l1.582 6.961a3.947 3.947 0 005.194 2.834zM29.833 26.36L25.34 28M20.087 16.814h7.786M26.007 22.854l1.573 4.333M6.995 22.855a3.944 3.944 0 01-2.126-5.578l3.37-6.254a1.334 1.334 0 011.63-.622l3.056 1.111c.632.23.994.893.846 1.548l-1.582 6.961a3.947 3.947 0 01-5.194 2.834zM3.167 26.36L7.66 28M12.914 16.814h-7.8M6.994 22.854L5.42 27.187M20.5 6.666l1.334-1.333M12.5 6.666l-1.333-1.333M16.5 5.333V4"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_1841_18070",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0H32V32H0z",
          transform: "translate(.5)"
        })
      })
    })]
  });
});
export var filterIconMap = {
  StagionaleIcon: StagionaleIcon,
  DeterminatoIcon: DeterminatoIcon,
  IndeterminatoIcon: IndeterminatoIcon,
  StageTirocinioIcon: StageTirocinioIcon,
  PartTimeIcon: PartTimeIcon,
  FullTimeIcon: FullTimeIcon,
  SpezzatoIcon: SpezzatoIcon,
  InteroIcon: InteroIcon,
  NoWeekendIcon: NoWeekendIcon,
  IslandTravelUmbrellaIcon: IslandTravelUmbrellaIcon,
  BarIcon: BarIcon,
  CucinaIcon: CucinaIcon,
  SalaIcon: SalaIcon,
  ReceptionIcon: ReceptionIcon,
  GlobeEuropeAfricaIcon: function GlobeEuropeAfricaIcon() {
    return /*#__PURE__*/_jsx(_GlobeEuropeAfricaIcon, {
      className: "h-4 w-4"
    });
  }
};